/**
 * Utility functions for session management
 */

/**
 * Check if the user is verified based on sessionStorage data
 * @returns {boolean} True if the user is verified, false otherwise
 */
export const isUserVerified = () => {
  const phoneNumber = sessionStorage.getItem('phoneNumber');
  const verificationTimestamp = sessionStorage.getItem('verificationTimestamp');
  
  // Verification is valid if:
  // 1. Phone number exists in sessionStorage
  // 2. Verification timestamp exists
  // 3. Verification is not older than 24 hours (86400000 ms)
  return !!phoneNumber && 
         !!verificationTimestamp && 
         (Date.now() - parseInt(verificationTimestamp)) < 86400000;
};

/**
 * Clear all session data
 */
export const clearSessionData = () => {
  sessionStorage.clear();
};

/**
 * Get the remaining time of the verification in milliseconds
 * @returns {number} Remaining time in milliseconds, or 0 if not verified
 */
export const getVerificationRemainingTime = () => {
  const verificationTimestamp = sessionStorage.getItem('verificationTimestamp');
  
  if (!verificationTimestamp) {
    return 0;
  }
  
  const elapsedTime = Date.now() - parseInt(verificationTimestamp);
  const remainingTime = 86400000 - elapsedTime; // 24 hours in milliseconds
  
  return Math.max(0, remainingTime);
};

/**
 * Format the remaining time as a string (e.g., "23 hours, 59 minutes")
 * @param {number} remainingTimeMs - Remaining time in milliseconds
 * @returns {string} Formatted time string
 */
export const formatRemainingTime = (remainingTimeMs) => {
  if (remainingTimeMs <= 0) {
    return 'Expired';
  }
  
  const hours = Math.floor(remainingTimeMs / (1000 * 60 * 60));
  const minutes = Math.floor((remainingTimeMs % (1000 * 60 * 60)) / (1000 * 60));
  
  return `${hours} ${hours === 1 ? 'hour' : 'hours'}, ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
};